import axios from 'axios';
import apisUrls from '../urls';

const editEndDateClientApi = (values) => {
  console.log(values);
  
  return axios.post(apisUrls?.editEndDateClient, values, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default editEndDateClientApi;
